import createBugsnagClient from "bugsnag-js";
var BugsnagClient = /** @class */ (function () {
    function BugsnagClient() {
        var _this = this;
        this.setup = function (bugsnagConfig) {
            _this.bugsnag = createBugsnagClient(bugsnagConfig);
        };
    }
    return BugsnagClient;
}());
export var bugsnagClient = new BugsnagClient();



//////////////////
// WEBPACK FOOTER
// ./src/features/bugsnag/bugsnagClient.ts
// module id = 148
// module chunks = 3